import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ViewManagerService } from '../../../../core/services/view-manager-service';
import { ScadenzarioRinvioForm } from '../../../form/scadenzario/scadenzario-rinvio-form.component';
import { Scadenza } from '../../../models/scadenza';
import { SezioneScadenze } from '../../../models/sezioni/sezione-scadenze';
import { RinvioAdapter } from './rinvio-adapter';

@Component({
    selector: 'div [scadenzario-form-rinvio]',
  templateUrl: '../../../form/scadenzario/scadenzario-rinvio-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ScadenzaRinvioConcreteFormComponent extends ScadenzarioRinvioForm implements OnInit {

  urlRinvio: string;
  idFascicolo: string;
  idSezione: string;
  isAdempimenti: boolean = false;
  @Output()
  onReturn: EventEmitter<SezioneScadenze> = new EventEmitter<SezioneScadenze>();

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService, private viewManager: ViewManagerService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Rinvia adempimento');
  }

  getScadenza() {
    return this.scadenza;
  }

  getRequestRinvio(request: RinvioAdapter) {
    if(this.isAdempimenti){
      this.operationService.rinvioAdempimento(this.urlRinvio, this.scadenza.id, request).subscribe(response=>this.sezioneScadenzeRinvio(response));
    } else {
      this.operationService.addRinvioToScadenza(this.urlRinvio, request, this.scadenza.id, this.idSezione).subscribe(response => this.sezioneScadenzeRinvio(response));
    }
  }

  sezioneScadenzeRinvio(response) {
    if (response.returnCode === 'OK') {
      this.viewManager._prossimiAdempimenti.next({param: null, timeOut:true});
      this.onReturn.emit(response.scadenza);
    }
  }

  inizializza(url: string, scadenza: Scadenza, idSezione: string, isAdempimenti: boolean = false) {
    this.idSezione = idSezione;
    this.urlRinvio = url;
    this.isAdempimenti = isAdempimenti;
    this.scadenza = scadenza;
    this.populateSelect();
    this.createForm();
  }
}
